import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "../../lib/content";

export const Testimonials = () => (
  <section className="bg-[#FAFAFB] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="overline mb-4">Early partners</p>
        <h2 className="font-heading max-w-2xl text-3xl font-medium tracking-tight text-[#0A0C14] sm:text-4xl lg:text-5xl">
          Built with the people who move real volume.
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 lg:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.08}>
            <figure data-testid={`testimonial-${i}`} className="nx-card flex h-full flex-col p-8 lg:p-10">
              <span className="font-heading text-6xl leading-none text-[#E8EDFF]">"</span>
              <blockquote className="flex-1 text-base leading-relaxed text-slate-700">{t.quote}</blockquote>
              <figcaption className="mt-8 flex items-center gap-4 border-t border-slate-100 pt-6">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#3B5FE8] text-sm font-semibold text-white">{t.initials}</span>
                <div>
                  <p className="text-sm font-semibold text-slate-900">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
